import { ConfirmAddToCart } from "@redotech/redo-agents-cards/support-agents/confirm-add-to-cart";
import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { literal } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";

const CartMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CART_ITEMS),
  structuredContent: ConfirmAddToCart.optional(),
});

export const CartMessageDbParser = CartMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type CartMessageType = z.infer<typeof CartMessageDbParser>;
